import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { Grid, Segment, Tab, Button } from "semantic-ui-react";
import GET_STATEMENT_OF_WORK from "../queries/StatementOfWorkQuery";
import GiraffeLoader from "./GiraffeLoader";
import ServerError from "./ServerError";

export const AgencyStatementOfWork = ({ selectedOnboardingToken }) => {
  const { data, loading, error } = useQuery(GET_STATEMENT_OF_WORK, {
    variables: { onboarding_token: selectedOnboardingToken },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <GiraffeLoader />;
  }

  if (error) {
    return <ServerError />;
  }

  const { statementOfWork } = data;

  return (
    <Tab.Pane>
      <Segment vertical>
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column width={8}>
              <b>Name</b>
            </Grid.Column>
            <Grid.Column width={2}>
              <p>Status</p>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
      <Segment vertical>
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column width={8}>
              <b>Statement of work</b>
            </Grid.Column>
            <Grid.Column width={2}>
              {statementOfWork?.value ? (
                <Button
                  as="a"
                  href={statementOfWork.value}
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                  primary
                >
                  Download
                </Button>
              ) : (
                <p>No Document Available</p>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </Tab.Pane>
  );
};

AgencyStatementOfWork.propTypes = {
  selectedOnboardingToken: PropTypes.string.isRequired,
};
